import React from 'react';

import Title from 'components/Title';
import TitleImages from 'components/TitleImages';
import ArticlesGrid from 'components/ArticlesGrid';
import ArticlesGridNew from 'components/ArticlesGridNew';
import Wolf from '../../../assets/Images/wolf.svg';
import Rabbit from '../../../assets/Images/rabbit.svg';
import { Wrapper } from './WidgetNews.style';
function WidgetNews({
  counterTitle = 0,
  appSettings = {},
  title = '',
  subtitle,
  titleColor = undefined,
  titleBackground = undefined,
  linkBackground = undefined,
  linkColor = undefined,
  readMoreLinkColor = undefined,
  firstReadMoreLinkColor = undefined,
  slug = '',
  isReverted,
  data = [],
  theme_id
}) {
  let { theme } = appSettings;
  return (
    <Wrapper>
      {theme == 6 ? (
        <>
          <ArticlesGridNew
            title={title}
            subtitle={subtitle}
            titleColor={titleColor}
            titleBackground={titleBackground}
            linkBackground={linkBackground}
            linkColor={linkColor}
            slug={slug}
            articles={data}
            isReverted={isReverted}
            readMoreLinkColor={readMoreLinkColor}
            firstReadMoreLinkColor={firstReadMoreLinkColor}
          />
        </>
      ) : (
        <>
          {' '}
          {theme === 4 ? (
            <TitleImages
              title={title}
              titleColor={titleColor}
              titleBackground={titleBackground}
              linkBackground={linkBackground}
              linkColor={linkColor}
              slug={slug}
              imageSrc={counterTitle === 0 ? Wolf : Rabbit}
            />
          ) : (
            <Title
              title={title}
              titleColor={titleColor}
              titleBackground={titleBackground}
              linkBackground={linkBackground}
              linkColor={linkColor}
              slug={slug}
            />
          )}
          <ArticlesGrid
            theme_id={theme_id}
            articles={data}
            readMoreLinkColor={readMoreLinkColor}
            firstReadMoreLinkColor={firstReadMoreLinkColor}
          />
        </>
      )}
    </Wrapper>
  );
}

export default WidgetNews;
